/**
 * Inteligência's own routes and nav entries: no Figma frame names this screen, so the sidebar
 * uses the parent-plus-children fold `Nav.tsx` builds every nested group from -- the group
 * heading ("Inteligência") and its first child ("Posts") share one path.
 *
 * One directory below `src/app/tenant`, so `../routes/index.ts`'s glob does not find it on its
 * own; `../routes.ts` folds `ONTOLOGY_ROUTES`/`ONTOLOGY_NAV` into the tenant area's own bundle.
 *
 * Every route requires `control_plane.write`: these screens are for a tenant-wide admin only,
 * the same all-or-nothing gate `../paths.ts`'s `USERS_PATH` gives Usuários, not the read-then-hide
 * split `../capacity/routes.ts` gives Créditos.
 */
import { createElement } from 'react';
import { Brain, FileText, MessageSquare, UserRound } from 'lucide-react';

import type { NavEntry, RouteModule } from '../../routes/contract';
import { OntologyPage } from './OntologyPage';
import { PendingProposalsBadge } from './ProposalsQueue';
import { om } from './messages';

const POSTS_PATH = '/t/$tenantId/inteligencia/posts';
const COMMENTS_PATH = '/t/$tenantId/inteligencia/comentarios';
const PROFILES_PATH = '/t/$tenantId/inteligencia/perfis';

function PostBadge(props: { params?: Record<string, string> }) {
  return createElement(PendingProposalsBadge, { ...props, scope: 'post' });
}

function ProfileBadge(props: { params?: Record<string, string> }) {
  return createElement(PendingProposalsBadge, { ...props, scope: 'profile' });
}

export const ONTOLOGY_ROUTES: RouteModule[] = [
  {
    path: POSTS_PATH,
    element: createElement(OntologyPage, { kind: 'posts' }),
    requires: 'control_plane.write',
    kind: 'data',
  },
  {
    path: COMMENTS_PATH,
    element: createElement(OntologyPage, { kind: 'comments' }),
    requires: 'control_plane.write',
    kind: 'data',
  },
  {
    path: PROFILES_PATH,
    element: createElement(OntologyPage, { kind: 'profiles' }),
    requires: 'control_plane.write',
    kind: 'data',
  },
];

export const ONTOLOGY_NAV: NavEntry[] = [
  {
    path: POSTS_PATH,
    label: () => om('nav.group'),
    requires: 'control_plane.write',
    icon: Brain,
    order: 50,
    kind: 'data',
  },
  {
    path: POSTS_PATH,
    label: () => om('nav.posts'),
    badge: PostBadge,
    requires: 'control_plane.write',
    parent: POSTS_PATH,
    icon: FileText,
    order: 51,
    kind: 'data',
  },
  {
    path: COMMENTS_PATH,
    label: () => om('nav.comments'),
    badge: PostBadge,
    requires: 'control_plane.write',
    parent: POSTS_PATH,
    icon: MessageSquare,
    order: 52,
    kind: 'data',
  },
  {
    path: PROFILES_PATH,
    label: () => om('nav.profiles'),
    badge: ProfileBadge,
    requires: 'control_plane.write',
    parent: POSTS_PATH,
    icon: UserRound,
    order: 53,
    kind: 'data',
  },
];
